// extracted by mini-css-extract-plugin
module.exports = {"GuestPodcastBlock":"GuestPodcastBlock_GuestPodcastBlock__w8d66","Title":"GuestPodcastBlock_Title__CYZoe","Description":"GuestPodcastBlock_Description__j2iZT"};